import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=c4056c80&scoped=true"
import script from "./Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./Icon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Icon.vue?vue&type=style&index=0&id=c4056c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4056c80",
  null
  
)

export default component.exports